<template>
  <div>
    <Organization
      :v="v"
      :is-alternative-service-edit="isAlternativeServiceEdit"
      :is-surcharge="isSurcharge"
      translationKey="noticeRecovery.applicant.org"
		>
			<slot></slot>
		</Organization>

    <TrusteeView
      :v="v.trustee"
      :role-type="roleValue"
      label="Сведения о представителе юридического лица"
      :statement-type="statementType"
    />
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';
import { required, requiredIf } from 'vuelidate/lib/validators';
import TrusteeView, {
  trusteeModel,
  trusteeValidate,
} from '@/components/services/elements/TrusteeView';
import { getValidationErrorText } from '@/utils/validate';
import Organization, {
  organizationModel,
  organizationValidation,
} from '../Organization';
import { Role } from '@/utils/dictionaries';

export const manualOrganizationModel = {
  ...organizationModel,
  trustee: cloneDeep(trusteeModel),
};

export const getManualOrganizationValidation = (
  organization,
  isAlternativeServiceEdit
) => ({
  ...organizationValidation,
  trustee: deepmerge(trusteeValidate(organization.trustee), {
    email: {
      required,
    },
    phone: {
      required,
    },
    documents: {
      authorityDocument: {
        file: {
          required: requiredIf(() => isAlternativeServiceEdit),
        },
      },
    },
  }),
});

export default {
  name: 'ManualOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
    isAlternativeServiceEdit: {
      type: Boolean,
      required: true,
    },
    isSurcharge: {
      type: Boolean,
      required: true,
    },
    statementType: {
      type: String,
      required: true,
    },
  },
  components: {
    Organization,
    TrusteeView,
  },
  data: () => ({
    roleValue: Role.ORGANIZATION,
    getValidationErrorText,
  }),
};
</script>
